import FormattedMessage from 'I18n/components/FormattedMessage';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { Text } from 'foundations-components/components/Text';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Form } from 'foundations-components/transitional/components/Form';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { INTERACTION_SECTIONS, INTERACTION_TARGETS } from 'payments-checkout-lib/constants/PageInteractionTracking';
import usePageInteractionTracking from '../../hooks/usePageInteractionTracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BillingAddressHeader = ({
  hasCalculateAtCheckoutTaxes,
  collectShippingAddress
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(Text, {
    "data-test-id": "billing-address-header",
    as: "h5",
    marginBlockStart: "600",
    marginBlockEnd: hasCalculateAtCheckoutTaxes ? '100' : '400',
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.billingInfo.header"
    })
  }), hasCalculateAtCheckoutTaxes && !collectShippingAddress && /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payments.taxAddressUsed"
  })]
});
const BillingSameAsShippingCheckbox = () => {
  const {
    formState,
    dispatch
  } = usePaymentFormContext();
  const {
    trackFirstFormFieldInteraction
  } = usePageInteractionTracking();
  const disabled = formState.get('isCheckoutSubmitPending');
  const billingSameAsShipping = formState.get('billingSameAsShipping');
  const handleBillingSameAsShippingToggle = ({
    target: {
      checked
    }
  }) => {
    trackFirstFormFieldInteraction({
      section: INTERACTION_SECTIONS.billingAddress,
      target: INTERACTION_TARGETS.billingSameAsShipping
    });
    dispatch({
      type: 'setBillingSameAsShipping',
      data: {
        value: checked
      }
    });
  };
  return /*#__PURE__*/_jsx(Checkbox, {
    color: "text-interactive-default",
    marginBlockStart: "300",
    checked: billingSameAsShipping,
    onChange: handleBillingSameAsShippingToggle,
    size: "small",
    "data-test-id": "billing-same-as-shipping-checkbox",
    disabled: disabled,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.billingInfo.billingInfoSameAsShippingInfo"
    })
  });
};
const CommonBillingAddress = ({
  collectShippingAddress,
  collectFullBillingAddress,
  children
}) => {
  const {
    formState,
    checkoutSession
  } = usePaymentFormContext();
  const billingSameAsShipping = formState.get('billingSameAsShipping');
  const hasCalculateAtCheckoutTaxes = checkoutSession.get('isAutomatedSalesTaxEnabled');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [collectShippingAddress && /*#__PURE__*/_jsxs(_Fragment, {
      children: [collectFullBillingAddress && /*#__PURE__*/_jsx(BillingAddressHeader, {
        hasCalculateAtCheckoutTaxes: hasCalculateAtCheckoutTaxes,
        collectShippingAddress: collectShippingAddress
      }), /*#__PURE__*/_jsx(BillingSameAsShippingCheckbox, {})]
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      "data-test-id": "billing-info-accordion",
      open: collectShippingAddress ? !billingSameAsShipping : true,
      renderContent: () => /*#__PURE__*/_jsxs(Form, {
        children: [!collectShippingAddress && /*#__PURE__*/_jsx(BillingAddressHeader, {
          hasCalculateAtCheckoutTaxes: hasCalculateAtCheckoutTaxes,
          collectShippingAddress: collectShippingAddress
        }), children]
      })
    })]
  });
};
export default CommonBillingAddress;